import {ModalWithHeaderProps} from "types/types";
import {ModalWithHeader} from "../../ui/Modal";
import {useEffect, useMemo, useState} from "react";
import {isValidUsername} from "../../utils";
import Input from "../../ui/Input";
import Field from "../../ui/Field";
import Button from "../../ui/Button";
import InfoLineIcon from "../../assets/icon/InfoLineIcon";
import {useUserInfo} from "../../hooks";
import CheckRoundIcon from "../../assets/icon/CheckRoundIcon";
import {setUserNameApi} from "../../api";
import {isSuccess} from "../../api/request";
import {FormattedMessage, useIntl} from "react-intl";
import {useDownMd} from "../../hooks/useLayout";

const ValidItem = ({
                       success = false,
                       text
                   }: {
    success?: boolean,
    text: string
}) => {
    const isDownMd = useDownMd()
    return <div className={`matchid-valid-status-item matchid-valid-status-${success ? 'success' : 'error'}`}>

        {success ? <CheckRoundIcon size={isDownMd ? 12 : 16}/> : <InfoLineIcon size={isDownMd ? 12 : 16}/>}
        <span>
            {text}
        </span>
    </div>
}

export default function UsernameModal({
                                          title,
                                          isOpen,
                                          onSuccess,
                                          ...props
                                      }: ModalWithHeaderProps & {
    onSuccess?: () => void
}) {
    const {username, refreshOverview} = useUserInfo()
    const {isLogin} = useUserInfo()
    const [val, setVal] = useState(username)
    const [error, setError] = useState('')//error from api
    const isDownMd = useDownMd()

    useEffect(() => {
        if (isOpen) {
            setVal(username)
            setError('')
        }
    }, [isOpen]);

    const isValid = useMemo(() => {
        return isValidUsername(val)
    }, [val])

    const isLength = useMemo(() => {
        return val.length >= 2 && val.length <= 32
    }, [val])

    const isSafe = isValid && isLength

    const [isSubmitting, setIsSubmitting] = useState(false)

    const onSubmit = async () => {
        if (isSubmitting) return
        try {
            setIsSubmitting(true)
            const res = await setUserNameApi({
                username: val
            })

            if (isSuccess(res)) {
                await refreshOverview()
                onSuccess && onSuccess()
            } else {
                setError(res.message)
            }

        } catch (error: any) {
            setError(error.message)
        } finally {
            setIsSubmitting(false)
        }
    }
    const intl = useIntl()

    return <ModalWithHeader isOpen={isOpen && isLogin} {...props} title={title || intl.formatMessage({
        id: username ? "editUsernameTitle" : "setUsernameTitle"
    })}>
        <div className="matchid-username-box">
            <Field label={intl.formatMessage({
                id: "username"
            })} error={error}>
                <Input
                    placeholder={intl.formatMessage({
                        id: "usernamePlaceholder"
                    })}
                    onChange={e => {
                        setVal(e.target.value)
                        setError('')
                    }}
                    value={val}
                />
            </Field>
            <div className="matchid-valid">
                <ValidItem success={isValid}
                           text={intl.formatMessage({
                               id: "usernameValidError"
                           })}/>
                <ValidItem success={isLength} text={intl.formatMessage({
                    id: "usernameLengthError"
                })}/>
                {/*<ValidItem success={isSafe} text={"Cannot contain sensitive words"}/>*/}
            </div>

            <Button disabled={!isSafe} loading={isSubmitting} style={{
                marginTop: isDownMd ? "36px" : "64px"
            }} onClick={onSubmit} size={"lg"} block highlight><FormattedMessage id="confirm"/></Button>
            <Button style={{
                marginTop: isDownMd ? "12px" : "24px"
            }} onClick={props.onClose} size={"lg"} block><FormattedMessage id="cancel"/></Button>
        </div>
    </ModalWithHeader>
}